<template>
  <div>
       <el-tabs v-model="activeName" type="card" >
    <el-tab-pane label="挂卖管理" name="1">
            <on-sale-list></on-sale-list>
    </el-tab-pane>
    <el-tab-pane label="我的卖单" name="2">
             <my-sale-list></my-sale-list>
    </el-tab-pane>
    <el-tab-pane label="我的买单" name="3">
             <my-buy-list></my-buy-list>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>

<script>
import OnSaleList from './components/OnSaleList'
import MySaleList from './components/MySaleList'
import MyBuyList from './components/MyBuyList'
export default {
  name: 'Sale',
 components:{OnSaleList,MySaleList,MyBuyList},
  data () {
    return {
         activeName: '1'
    }
  },
  mounted(){
	const tempActiveName=this.$route.query.activeName
	console.log('tempActiveName:'+tempActiveName)
	if(!!tempActiveName){
		this.activeName=tempActiveName
	}

  // console.log(555);
  if (this.$route.query) {
    console.log(this.$route.query.activeName);
  }
  },
  methods: {}
}
</script>

<style lang='scss' scoped>
</style>
